module.exports = __webpack_public_path__ + "media/images/lb/527-24818bec9cb45cf580e1fb48038a07d7.svg";